<template>
  <div class="collapsible-list">
    <a @click.prevent="open = !open">
      <b-icon :icon="icon" custom-size="default"></b-icon>
      <span>{{ title }}</span>
      <b-icon
        :icon="open ? 'chevron-down' : 'chevron-up'"
        custom-size="default"
      ></b-icon>
    </a>
    <div>
      <div v-for="row in visibleListRows" :key="row.label" class="navbar-item">
        <div style="display: block;">
          <div>
            <span
              ><strong>- {{ row.label }}</strong></span
            >
            <b-icon
              pack="mdi"
              v-if="row.check"
              :icon="row.check"
              custom-size="default"
            ></b-icon>
          </div>
          <div v-if="row.value">
            <b-icon
              pack="mdi"
              icon="chevron-right"
              custom-size="default"
            ></b-icon>
            <a target="_blank" :href="row.valueUrl" v-if="row.valueUrl">
              <b-icon
                pack="mdi"
                icon="file-document"
                custom-size="default"
              ></b-icon>
              {{ row.value }}
            </a>
            <span v-else>{{ row.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleList',
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    visibleListRows() {
      return this.open && this.options
    }
  },
  data() {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.collapsible-list {
  display: block;
}
</style>
